import { ListItem, ListItemText } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { useTranslation } from "react-i18next";
import { vesselTypeToTranslationKey } from "../functions/vesselTypeToTranslationKey";
import { VesselMapItem } from "../types/mapItems";

const useStyles = makeStyles((theme) => ({
  divider: {
    borderBottomColor: theme.palette.primary.light,
  },
}));

interface Props {
  vessel: VesselMapItem;
  style: React.CSSProperties;
  onClick: (v: VesselMapItem) => void;
}

const VesselListItem = ({ vessel, style, onClick }: Props): JSX.Element => {
  const { t } = useTranslation("vessels");
  const classes = useStyles();

  return (
    <ListItem
      button
      divider
      classes={{ divider: classes.divider }}
      style={style}
      onClick={() => onClick(vessel)}
    >
      <ListItemText
        primary={vessel.name}
        primaryTypographyProps={{ noWrap: true, title: vessel.name }}
        secondaryTypographyProps={{
          color: "inherit",
          noWrap: true,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          title: t(vesselTypeToTranslationKey(vessel.shipType)),
        }}
        secondary={t(vesselTypeToTranslationKey(vessel.shipType))}
      />
    </ListItem>
  );
};

export default VesselListItem;
